import { getPageOrDefault, DEFAULT_PAGE } from '@is24at/react-pagination';
import { SearchParamsEnum } from 'utils/enums';
import canonicalUrl from './canonicalUrl';

const prev = ({ searchQuery = {}, pathname }: any = {}) => {
  const page = getPageOrDefault(searchQuery);
  if (DEFAULT_PAGE === page) {
    return undefined;
  }
  return page === 2
    ? pathname
    : canonicalUrl({
        searchQuery: {
          ...searchQuery,
          [SearchParamsEnum.page]: page - 1,
        },
        pathname,
      });
};

export default prev;
